import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.41 20L17 8.41V15h2V5H9v2h6.59L4 18.59z"
}), 'CallMadeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMadeTwoTone.js
// module id = 2598
// module chunks = 2